/**
 * groupInstanceRelation模块接口列表
 */
import $http from '../utils/http' // 导入http中创建的axios实例

const groupInstanceRelation = {
  // 增加groupInstanceRelation关联表
  createGroupInstanceRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupInstanceRelation/create`, params)
  },
  // 删除groupInstanceRelation关联表
  deleteGroupInstanceRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupInstanceRelation/deleteByGroupIdAndInstanceId`, params)
  }
}

export default groupInstanceRelation



// WEBPACK FOOTER //
// ./src/api/groupInstanceRelation.js